import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { VerifyUserMPin } from "../../api/userAuth";
import { loginSuccess } from "../../features/authSlice";
import { useWallet } from "../../context/walletContext";
import AuthShell from "../../components/auth/AuthShell";
import AuthOtpInput from "../../components/auth/AuthOtpInput";
import { showToastMessage } from "../../utils/toastUtils";
import socket from "../../socket/socket";

const LoginForm = () => {
  const [form, setForm] = useState({ mpin: "" });
  const { username } = useParams();
  const { refreshadminWallet } = useWallet();
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e, mpinValue) => {
    if (e?.preventDefault) e.preventDefault();
    const mpin = mpinValue ?? form.mpin;

    if (!username) {
      showToastMessage("error", "Something went wrong. Please login again.");
      return;
    }
    if (!/^\d{6}$/.test(mpin || "")) {
      showToastMessage("error", "MPIN must be exactly 6 digits!");
      return;
    }

    try {
      setLoading(true);
      const payload = { userName: username, mpin };
      const result = await VerifyUserMPin(payload);

      if (result.success) {
        const user = result?.data?.user;
        if (user?.role !== "super_admin" && user?.role !== "admin") {
          showToastMessage("error", "Access denied. Admin credentials required.");
          return;
        }
        dispatch(loginSuccess({ userInfo: user }));
        socket.emit("join", { userId: user._id, portal: "admin" });
        showToastMessage("success", "Login Successful!");
        navigate("/admin/dashboard");
        refreshadminWallet();
      } else {
        const activeDevice = result?.data?.activeDevice;
        const activeLabel = activeDevice?.label ? ` Active: ${activeDevice.label}` : "";
        showToastMessage(
          "error",
          `${result?.message || "Login failed!"}${result?.code === "ACTIVE_DEVICE_SESSION" ? activeLabel : ""}`
        );
      }
    } catch {
      showToastMessage("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Welcome back"
      title="Enter your MPIN"
      subtitle={
        username ? `Signed in as ${String(username).toUpperCase()}` : undefined
      }
    >
      <form onSubmit={handleSubmit} noValidate autoComplete="off">
        <AuthOtpInput
          length={6}
          value={form.mpin}
          autoFocus
          type="password"
          onChange={(clean) => {
            setForm({ ...form, mpin: clean });
            if (clean.length === 6) {
              setTimeout(() => handleSubmit(null, clean), 400);
            }
          }}
        />

        <div className="ds-auth-row mt-3 mb-4">
          <label className="ds-auth-check">
            <input
              type="checkbox"
              checked={remember}
              onChange={() => setRemember(!remember)}
            />
            Remember me
          </label>
        </div>

        <button
          type="submit"
          className="ds-btn ds-btn-primary ds-btn-block"
          disabled={loading || form.mpin.length !== 6}
        >
          {loading ? "Verifying..." : "Continue"}
        </button>
      </form>
    </AuthShell>
  );
};

export default LoginForm;
